import TitlePatientNameSelect from "./TitlePatientNameSelect";

export default TitlePatientNameSelect;
